// extracted by mini-css-extract-plugin
export default {"dragCancelContainer":"Build_dragCancelContainer__zOh3y"};